/**
 * Bloc survey object
 */
var Survey = (function (){


	var init = function() {
       $('.survey-block').each(function (index, survey) {
         $(survey).find('a').click(function (){
           $(survey).find('.answer').css('display', 'none');
           $(survey).find('.answer').eq(parseInt($(this).data('index'))).css('display', 'block');
         });
       });

	};

  return {
    init: init
  }

})();
